const LoadingComponent = ({ themeColor = '#007bff', message = 'Loading Conversations' }) => (
	<div className="flex flex-col items-center justify-center h-full bg-gradient-to-br from-gray-50 to-gray-100">
		<div className="text-center p-8">
			<div className="space-y-3">
				<h3 className="text-xl font-semibold text-gray-700">{message}</h3>
				<div className="flex items-center justify-center space-x-1">
					<span className="text-gray-500">Please wait</span>
					<div className="flex space-x-1 mt-1">
						<div
							className="w-2 h-2 rounded-full animate-bounce"
							style={{ backgroundColor: themeColor, animationDelay: '0ms' }}
						/>
						<div
							className="w-2 h-2 rounded-full animate-bounce"
							style={{ backgroundColor: themeColor, animationDelay: '150ms' }}
						/>
						<div
							className="w-2 h-2 rounded-full animate-bounce"
							style={{ backgroundColor: themeColor, animationDelay: '300ms' }}
						/>
					</div>
				</div>
			</div>

			<div className="mt-6 w-64 bg-gray-200 rounded-full h-2 overflow-hidden">
				<div
					className="h-full rounded-full animate-pulse"
					style={{
						backgroundColor: themeColor,
						width: '50%',
						animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
					}}
				/>
			</div>
		</div>
	</div>
);

export default LoadingComponent;
